import { createContext, useContext } from 'react';

import type { THEMES } from './config';

export interface IContext {
    /** Тема */
    theme: typeof THEMES[number];
}

export const Context = createContext({} as IContext);

export const useMainBannerContext = () => useContext<IContext>(Context);
